import { ChevronLeft, ChevronRight } from 'lucide-react';
import { addDays, dayLabel } from '../stats/statsData';
import { FONT_BODY } from '../theme';

const CHIPS = [
  { off: -1, label: 'Yesterday' },
  { off: 0, label: 'Today' },
  { off: 1, label: 'Tomorrow' },
];

function Arrow({ t, label, disabled, onClick, children }) {
  return (
    <button type="button" aria-label={label} title={label} disabled={disabled} onClick={onClick} style={{
      width: 44, height: 40, flexShrink: 0, borderRadius: 10,
      background: t.cardBg, border: `1px solid ${t.cardBorder}`, color: t.text,
      cursor: disabled ? 'default' : 'pointer', opacity: disabled ? 0.35 : 1,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>{children}</button>
  );
}

/* Yesterday / Today / Tomorrow for the usual case, plus arrows and a date
 * field to reach any earlier day (Stats opens Meals on a past day too).
 * Nothing after tomorrow: food isn't planned that far ahead. */
export function DayPicker({ t, isDark, value, today, onChange }) {
  const tomorrow = addDays(today, 1);
  const go = (k) => { if (k && k <= tomorrow) onChange(k); };
  // With none of the chips lit, the date field is what shows the day.
  const other = !CHIPS.some(c => addDays(today, c.off) === value);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <div style={{ display: 'flex', gap: 6 }}>
        {CHIPS.map(c => {
          const k = addDays(today, c.off);
          const active = k === value;
          return (
            <button key={c.off} type="button" aria-pressed={active} onClick={() => go(k)} style={{
              flex: 1, padding: '10px 8px', borderRadius: 10, cursor: 'pointer',
              background: active ? t.accentSoft : t.cardBg,
              border: `1px solid ${active ? t.accentBorder : t.cardBorder}`,
              color: active ? t.accent : t.text,
              fontFamily: FONT_BODY, fontWeight: 600, fontSize: 13, transition: 'all 0.15s',
            }}>
              {c.label}
              <div style={{ fontSize: 10, color: active ? t.accent : t.textFaint, marginTop: 2, fontWeight: 500 }}>
                {dayLabel(k)}
              </div>
            </button>
          );
        })}
      </div>
      <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
        <Arrow t={t} label="Previous day" onClick={() => go(addDays(value, -1))}>
          <ChevronLeft size={18} />
        </Arrow>
        <input type="date" aria-label="Day to show" value={value} max={tomorrow}
          onChange={e => go(e.target.value)}
          style={{
            flex: 1, minWidth: 0, height: 40, padding: '0 12px', borderRadius: 10,
            background: other ? t.accentSoft : t.inputBg, color: other ? t.accent : t.text,
            border: `1px solid ${other ? t.accentBorder : t.inputBorder}`,
            fontFamily: FONT_BODY, fontSize: 14, fontWeight: 600, textAlign: 'center', outline: 'none',
            colorScheme: isDark ? 'dark' : 'light',
          }} />
        <Arrow t={t} label="Next day" disabled={value >= tomorrow} onClick={() => go(addDays(value, 1))}>
          <ChevronRight size={18} />
        </Arrow>
      </div>
    </div>
  );
}
